import useAccountSettings from '@/composables/logged-in-user-account/account-settings';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useRepo from '@/nebula/repo';
import { computed } from 'vue';
import { generateSecret, sha256Hex } from '@/lib/personal-access-token';
import { personalAccessToken as personalAccessTokenConfig } from 'shared/api/query/configs.json';

export default function usePersonalAccessTokens() {
  const repo = useRepo(personalAccessTokenConfig.model);
  const { loggedInUser } = useLoggedInUser();
  const { accountSettings } = useAccountSettings();

  const maxLifetimeDays = computed(() => accountSettings.value.personalAccessTokenMaxLifetimeDays);

  const createPersonalAccessToken = ({ name, expiresAt }) => {
    const secret = generateSecret();
    return sha256Hex(secret)
      .then((tokenHash) => repo.createSingle({
        user: { uid: loggedInUser.value.uid },
        name,
        tokenHash,
        expiresAt,
      }))
      .then(() => secret);
  };

  const rotatePersonalAccessToken = (personalAccessToken, { expiresAt }) => {
    const secret = generateSecret();
    return sha256Hex(secret)
      .then((tokenHash) => repo.mutateSingle({ uid: personalAccessToken.uid, tokenHash, expiresAt }))
      .then(() => secret);
  };

  const revokePersonalAccessToken = (personalAccessToken) => repo.deleteSingle(personalAccessToken.uid);

  return {
    personalAccessTokens: repo.entityList,
    maxLifetimeDays,
    createPersonalAccessToken,
    rotatePersonalAccessToken,
    revokePersonalAccessToken,
  };
}
